import { render } from "./RankingTable.vue?vue&type=template&id=7410f5f8&scoped=true"
import script from "./RankingTable.vue?vue&type=script&lang=js"
export * from "./RankingTable.vue?vue&type=script&lang=js"

import "./RankingTable.vue?vue&type=style&index=0&id=7410f5f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7410f5f8"]])

export default __exports__